import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface VideoEmbedProps {
  type: 'vimeo' | 'youtube';
  id: string;
  title?: string;
}

const VideoEmbedded: React.FC<VideoEmbedProps> = ({ type, id, title = 'Video Player' }) => {
  const getEmbedUrl = () => {
    switch (type) {
      case 'youtube':
        return `https://www.youtube.com/embed/${id}`;
      case 'vimeo':
        return `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0`;
      default:
        return '';
    }
  };

  const embedUrl = getEmbedUrl();

  return (
    <Card elevation={3}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Box
          sx={{
            position: 'relative',
            paddingTop: '56.25%',
          }}
        >
          <iframe
            src={embedUrl}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={title}
          ></iframe>
        </Box>
      </CardContent>
    </Card>
  );
};

export default VideoEmbedded;
